import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "home",
  "use": "home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.49399 9.75879L11.494 2.44629H12.506L20.506 9.75879L20.75 10.3124V20.9999L20 21.7499H4L3.25 20.9999V10.3124L3.49399 9.75879ZM4.75 10.6429V20.2499H19.25V10.6429L12 4.01598L4.75 10.6429Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol